// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titles-count[data-v-7a4dd899]{color:#b9bdcc;font-size:12px;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
